export default {
    // hostUrl: "http://127.0.0.1:8000",
    hostUrl: "https://admin.newvisionoman.com",
    token: localStorage.getItem("token") || null,
    lang: localStorage.getItem("lang") || 'en',
    permissions: localStorage.getItem("permissions") || [],
}